"use client";

import { FC } from "react";
import { Pagination, Autoplay, A11y } from "swiper/modules";
import { Swiper as SwiperComponent, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/pagination";

import { QuoteCarouselSectionRecord } from "@graphql/types/graphql";

import { Quote } from "../../InlineBlocks/Quote";
import s from "./QuoteCarouselSection.module.scss";

interface Props {
  data: QuoteCarouselSectionRecord;
}

export const QuoteCarouselSection: FC<Props> = ({ data: { quotes } }) => {
  if (!quotes || quotes.length === 0) return null;

  return (
    <div className={s.Swiper}>
      <SwiperComponent
        autoplay={{
          delay: 5000,
          disableOnInteraction: true,
        }}
        spaceBetween={16}
        slidesPerView={1}
        slidesPerGroup={1}
        pagination={{ clickable: true }}
        breakpoints={{
          768: {
            spaceBetween: 24,
          },
        }}
        modules={[A11y, Pagination, Autoplay]}
      >
        {quotes.map((quote) => (
          <SwiperSlide className={s.Slide} key={quote.id}>
            <Quote data={quote} />
          </SwiperSlide>
        ))}
      </SwiperComponent>
    </div>
  );
};
